// The per-file size rule, mirrored from the server's src/storage/file-types.ts
// so an author hears about an oversized file before uploading it. The server
// decides; this only saves the round trip. Nothing is refused for its type here.

const MB = 1024 * 1024
export const MAX_VIDEO_BYTES = 200 * MB
export const MAX_FILE_BYTES = 95 * MB
const VIDEO = new Set(["mp4", "webm", "mov", "mkv", "m4v"])

export function extensionOf(name: string): string {
  const dot = name.lastIndexOf(".")
  return dot > 0 ? name.slice(dot + 1).toLowerCase() : ""
}

export function maxBytesFor(name: string): number {
  return VIDEO.has(extensionOf(name)) ? MAX_VIDEO_BYTES : MAX_FILE_BYTES
}

/** Why a file is too large, or null. */
export function sizeProblem(file: { name: string; size: number }): string | null {
  const limit = maxBytesFor(file.name)
  if (file.size <= limit) return null
  const kind = limit === MAX_VIDEO_BYTES ? " for videos" : ""
  return `"${file.name}" is over the ${limit / MB} MB limit${kind}`
}
